<!--
 * @Author: v_hllhe
 * @Date: 2022-12-21 13:13:27
 * @LastEditors: v_hllhe
 * @LastEditTime: 2022-12-26 15:25:12
 * @Description:
-->
<template>
<div>
  <div class="feature">
    <div class="pulse1"></div>
    <div class="pulse2"></div>
    <div class="pulse3"></div>
    <!-- <div class="pulse4"></div> -->
  </div>
</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  name: '',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteLeave() { // 路由离开钩子
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/convert-viewport";

  .pulse1, .pulse2, .pulse3, .pulse4{
    position: absolute;
    width: vw(180);
    height: vh(20);
    top: vh(94);
    left: 50%;
    border-radius: 50%;
    opacity: 1;
    z-index: 10000;
    animation: warn 4s linear infinite;
    // box-shadow: 5px 5px 15px red;
  }
  .pulse1 {
    animation-delay: 0s;
  }
  .pulse2 {
    animation-delay: 1.3s;
  }
  .pulse3 {
    animation-delay: 2.3s;
  }
  .pulse4 {
    animation-delay: 3s;
  }
  @keyframes warn {
		0% {
			transform: scale(1.0);
			opacity: 1;
		}
		25% {
      box-shadow: 5px 5px 15px #1F63EE;
			transform: scale(1.6, 2.0);
			opacity: 0.50;
		}
		50% {
      box-shadow: 5px 5px 15px #1F63EE;
			transform: scale(2.8, 3.2);
			opacity: 0.40;
		}
		75% {
      box-shadow: 5px 5px 15px #1F63EE;
			transform: scale(3.8, 4.2);
			opacity: 0.30;
		}
		100% {
      box-shadow: 5px 5px 15px #1F63EE;
			transform: scale(5.3, 5.0);
			opacity: 0;
		}
	}
</style>
